import type { ReactNode } from "react";

/** 18px line icons from the design system. They draw in `currentColor`. */
function Icon({ size = 18, children }: { size?: number; children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="shrink-0"
    >
      {children}
    </svg>
  );
}

export const BoardIcon = () => (
  <Icon>
    <rect x="2" y="3" width="4" height="12" rx="1" />
    <rect x="7" y="3" width="4" height="8" rx="1" />
    <rect x="12" y="3" width="4" height="10" rx="1" />
  </Icon>
);

export const CalendarIcon = () => (
  <Icon>
    <rect x="2.5" y="3.5" width="13" height="12" rx="2" />
    <path d="M2.5 7.5H15.5M6 2V5M12 2V5" />
  </Icon>
);

export const BellIcon = () => (
  <Icon>
    <path d="M4.5 12.5V8a4.5 4.5 0 0 1 9 0v4.5l1.5 1.5H3z" />
    <path d="M7.5 16h3" />
  </Icon>
);

export const ClockIcon = () => (
  <Icon>
    <circle cx="9" cy="9" r="6.5" />
    <path d="M9 5.5V9l2.5 1.5" />
  </Icon>
);

export const ArchiveIcon = () => (
  <Icon>
    <rect x="2" y="3" width="14" height="4" rx="1" />
    <path d="M3.5 7v7a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V7M7.5 10h3" />
  </Icon>
);

export const UserIcon = () => (
  <Icon>
    <circle cx="9" cy="6" r="3" />
    <path d="M3 16c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" />
  </Icon>
);

export const MenuIcon = () => (
  <Icon size={20}>
    <path d="M3 5h12M3 9h12M3 13h12" />
  </Icon>
);

export const UpDownIcon = () => (
  <Icon size={16}>
    <path d="M6 7l3-3 3 3M6 11l3 3 3-3" />
  </Icon>
);

export const ChevronRightIcon = () => (
  <Icon size={16}>
    <path d="M7 4l5 5-5 5" />
  </Icon>
);

export const CheckIcon = () => (
  <Icon size={16}>
    <path d="M4 9.5l3 3 7-7" />
  </Icon>
);

export const ChevronLeftIcon = () => (
  <Icon size={16}>
    <path d="M11 4L6 9l5 5" />
  </Icon>
);

export const ChevronDownIcon = () => (
  <Icon size={16}>
    <path d="M5 7l4 4 4-4" />
  </Icon>
);

export const SearchIcon = () => (
  <Icon size={16}>
    <circle cx="8" cy="8" r="5" />
    <path d="M12 12l3.5 3.5" />
  </Icon>
);

export const CloseIcon = () => (
  <Icon>
    <path d="M4.5 4.5l9 9M13.5 4.5l-9 9" />
  </Icon>
);

export const MoreIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" aria-hidden="true" className="shrink-0">
    <circle cx="4" cy="9" r="1.4" />
    <circle cx="9" cy="9" r="1.4" />
    <circle cx="14" cy="9" r="1.4" />
  </svg>
);

export const GripIcon = () => (
  <svg width="12" height="16" viewBox="0 0 12 16" fill="currentColor" aria-hidden="true" className="shrink-0">
    {[3, 8, 13].map((y) => (
      <g key={y}>
        <circle cx="3" cy={y} r="1.3" />
        <circle cx="9" cy={y} r="1.3" />
      </g>
    ))}
  </svg>
);

export const TrashIcon = () => (
  <Icon size={16}>
    <path d="M3 5h12M7 5V3.5h4V5M5 5l.7 10h6.6L13 5" />
  </Icon>
);

export const WarningIcon = () => (
  <Icon>
    <path d="M9 2.5l7 12.5H2z" />
    <path d="M9 7.5v3.2M9 13h.01" />
  </Icon>
);

export const ChatIcon = () => (
  <Icon>
    <path d="M3 4.5A1.5 1.5 0 0 1 4.5 3h9A1.5 1.5 0 0 1 15 4.5v6.5a1.5 1.5 0 0 1-1.5 1.5H8l-3.5 3v-3h0A1.5 1.5 0 0 1 3 11z" />
    <path d="M6 6.5h6M6 9h4" />
  </Icon>
);
